import 'bootstrap';
import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

import Toaster from '../lib/toaster';

export default class extends Controller {
  static targets = [];

  connect() {
    $('body').on('new-message', (e, opts) => {
      const toastOptions = opts;
      toastOptions.delay = toastOptions.delay || 4000;
      Toaster.showToast(toastOptions);
    });
  }
}
